import React from 'react';
import { Section } from '../ui/Section';
import { ArrowRight, TrendingUp, Building2, BadgeDollarSign, PiggyBank, Landmark, Hourglass } from 'lucide-react';
export function WhyFailed() {
  const problems = [{
    title: 'Prices are insane.',
    desc: 'Everyone fights over the same overpriced listings on the same giant apps.',
    icon: TrendingUp
  }, {
    title: 'Landlords win, you lose.',
    desc: 'Your rent pays off their mortgage while you build nothing.',
    icon: Building2
  }, {
    title: 'Agents cash in.',
    desc: 'Big commissions come straight out of your pocket.',
    icon: BadgeDollarSign
  }, {
    title: 'Saving 20% feels impossible.',
    desc: "And that's no accident — it's designed that way.",
    icon: PiggyBank
  }, {
    title: 'A nation of renters by design.',
    desc: "Let's be real — bankers and the government are landlords themselves, so they want everybody renting by design. That's exactly why retail house prices are so expensive.",
    icon: Landmark,
    wide: true
  }, {
    title: 'Yes, our parents had it easier.',
    desc: "Homes were cheaper and easier to buy back then — no point pretending otherwise. But you've got two choices: keep complaining about it, or find a different solution that actually works right now in 2026. That's exactly what this home auction blueprint gives you.",
    icon: Hourglass,
    wide: true
  }];
  return <Section theme="black" className="border-b border-slate-100" data-id="element-470">
      <div className="mb-6 flex flex-col items-center" data-id="element-471">
        <div className="flex items-center gap-4 mb-4" data-id="element-472">
          <div className="h-1 w-8 bg-orange-500 rounded-full" data-id="element-473"></div>
          <span className="text-orange-600 text-xs font-bold tracking-wider uppercase" data-id="element-474">
            Real Talk
          </span>
          <div className="h-1 w-8 bg-orange-500 rounded-full" data-id="element-475"></div>
        </div>
      </div>

      <h2 className="text-3xl md:text-4xl font-display font-bold mb-6 text-center max-w-3xl mx-auto text-slate-900 leading-tight" data-id="element-476">
        The System Was Built to Keep You Renting —{' '}
        <span className="text-orange-500" data-id="element-477">Here's How to Beat It.</span>
      </h2>

      <p className="text-lg md:text-xl text-slate-600 text-center max-w-2xl mx-auto mb-14" data-id="element-478">
        A{' '}
        <span className="font-semibold text-slate-800" data-id="element-479">
          beginner-friendly blueprint
        </span>{' '}
        for anyone who wants their first house cheaper and to finally become a
        homeowner. Let's be honest:
      </p>

      <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-480">
        {problems.map((item, idx) => {
        const Icon = item.icon;
        return <div key={idx} className={`bg-white p-8 rounded-2xl border border-slate-200 border-l-4 border-l-orange-500 shadow-sm flex gap-6 items-start hover:shadow-md transition-shadow duration-300 ${item.wide ? 'md:col-span-2' : ''}`} data-id="element-481">
              <div className="shrink-0 mt-1 bg-orange-50 p-2.5 rounded-xl" data-id="element-482">
                <Icon className="w-6 h-6 text-orange-500" data-id="element-483" />
              </div>
              <div data-id="element-484">
                <h3 className="text-xl font-display font-bold mb-2 text-slate-900" data-id="element-485">
                  {item.title}
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-486">{item.desc}</p>
              </div>
            </div>;
      })}
      </div>

      {/* Solution banner */}
      <div className="bg-orange-500 rounded-2xl p-8 md:p-10 flex gap-5 items-start text-left shadow-md" data-id="element-487">
        <div className="shrink-0 mt-1 bg-white/20 p-2 rounded-full" data-id="element-488">
          <ArrowRight className="w-6 h-6 text-white" data-id="element-489" />
        </div>
        <p className="text-white text-lg md:text-xl font-semibold leading-relaxed" data-id="element-490">
          Here's the real secret to a cheap house up to{' '}
          <span className="font-bold underline decoration-white/40" data-id="element-491">
            50% off
          </span>
          : <span className="font-bold" data-id="element-492">home auctions</span> — with the right
          blueprint. Keep reading this page and you'll learn exactly how to do
          it as a complete beginner,{' '}
          <span className="font-bold" data-id="element-493">even with no savings.</span>
        </p>
      </div>
    </Section>;
}